var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{staticClass:"back-link",attrs:{"data-test-id":"BackLinkComponent"},on:{"click":_vm.onBackClick}},[_c('span',{staticClass:"text-red"},[_vm._v("Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }